import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import { useLanguage } from "../../i18n/LanguageContext";

function Projects() {
  const { t } = useLanguage();
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          {t("projects.title")}
        </h1>
        <p style={{ color: "white" }}>
          {t("projects.intro")}
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="/images/yourParking.png"
              isBlog={false}
              title={t("projects.p1.title")}
              description={t("projects.p1.description")}
              ghLink="https://github.com/Breinersmartinez/YourParking-Community-Edition"
              demoLink="https://aplicacion-de-gestion-para-parqueadero.vercel.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="/images/SdnShare.png"
              isBlog={false}
              title={t("projects.p2.title")}
              description={t("projects.p2.description")}
              ghLink="https://github.com/JosephRodriri/SdnShare/tree/BreinerMartinezDev"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="/images/clinicCore.png"
              isBlog={false}
              title={t("projects.p3.title")}
              description={t("projects.p3.description")}
              ghLink="https://github.com/Breinersmartinez/ClinCore"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="/images/IoT%20Distributed%20Sensor%20System.png"
              isBlog={false}
              title={t("projects.p4.title")}
              description={t("projects.p4.description")}
              ghLink="https://github.com/Breinersmartinez/iot-distributed-sensor-system"
              demoLink="https://iot-distributed-sensor-system-whit.vercel.app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="/images/AlphaBrein.png"
              isBlog={false}
              title={t("projects.p5.title")}
              description={t("projects.p5.description")}
              ghLink="https://github.com/Breinersmartinez/AlphaBrein"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;